var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bizfly-ui bizfly-steps"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,class:[
      'bizfly-steps__step',
      _vm.currentStep === index ? 'active' : '',
      _vm.currentStep > index ? 'done' : ''
    ]},[_c('span',{staticClass:"bizfly-steps__step--text"},[(_vm.currentStep > index)?_c('i',{staticClass:"el-icon-check"}):_c('span',[_vm._v(_vm._s(index + 1))])]),_c('span',{staticClass:"bizfly-steps__step--description"},[_vm._v(_vm._s(step.description))]),_c('span',{staticClass:"bizfly-steps__step--line"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }